import React from "react";
import Config from '../../config';

export default (props) => {
  if (!props.visible) {
    return null;
  }

  return (<div className={props.iframe ? "full-screen-wrapper-iframe" : "full-screen-wrapper"}>
    <div className="message-loading-container-centered">
      <div className="message-loading-left-panel message-loading-panel-settings">
        <div className="message-loading-left-panel-spinner">
        </div>
      </div>
      <div className="message-loading-right-panel message-loading-panel-settings">
        <h1>{props.title}</h1>
        <p>{props.text}</p>
      </div>
    </div>
  </div>);
};




// WEBPACK FOOTER //
// ./src/components/common/loaderView.js